import * as React from 'react';
import { ITableHeader } from './Table.interfaces';

const TableHeader = (props: ITableHeader) => {
  const { data, tableName, metadata, cellRenderer, hiddenColumns } = props;
  return <thead>{cellRenderer(data, tableName, metadata, hiddenColumns)}</thead>;
};

export default TableHeader;
